if (!customElements.get('contact-form-component')) {
  customElements.define(
    'contact-form-component',
    class ContactFormComponent extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(event) {
        let isValid = true;

        this.querySelectorAll('[data-contact-checkbox-group]').forEach((group) => {
          const hiddenInput = group.querySelector('[data-contact-checkbox-value]');
          const checkboxes = group.querySelectorAll('[data-contact-checkbox-option]');
          const checkedValues = Array.from(checkboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.value);

          if (hiddenInput) {
            hiddenInput.value = checkedValues.join(', ');
          }

          if (group.dataset.required !== 'true') {
            this.hideCheckboxGroupError(group);
            return;
          }

          if (checkedValues.length === 0) {
            isValid = false;
            this.showCheckboxGroupError(group);
          } else {
            this.hideCheckboxGroupError(group);
          }
        });

        if (!isValid) {
          event.preventDefault();
          const firstError = this.querySelector('[data-contact-checkbox-error]:not(.hidden)');
          firstError?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }

      showCheckboxGroupError(group) {
        const error = group.querySelector('[data-contact-checkbox-error]');
        if (error) {
          error.classList.remove('hidden');
        }
      }

      hideCheckboxGroupError(group) {
        const error = group.querySelector('[data-contact-checkbox-error]');
        if (error) {
          error.classList.add('hidden');
        }
      }
    }
  );
}
